import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";

type ViewMode = 'primary' | 'secondary' | 'danger';
type Size = 'small' | 'normal';

interface IBlockProps {
    caption: string;
    viewMode?: ViewMode;
    size?: Size;
    width?: string|number;
    margin?: string;
    disabled?: boolean;
    onClick?: () => void;
}

interface IStyledButtonProps {
    viewMode?: ViewMode;
    size?: Size;
    width?: string|number;
    margin?: string;
    disabled?: boolean;
}

const getViewModeBackground = (viewMode?: ViewMode) => {
    switch(viewMode) {
        case 'secondary':
            return '#FFFFFF';
        case 'danger':
            return '#EE505A';
        case 'primary':
        default:
            return '#7075E9';
    }
};

const Button = styled.button<IStyledButtonProps>`
    background: ${({viewMode}) => getViewModeBackground(viewMode)};
    border-radius: 10px;
    font-weight: 500;
    font-size: ${({size}) => size === 'small' ? '14px' : '16px'};
    color: ${({viewMode}) => viewMode === 'secondary' ? '#7075E9' : '#FFFFFF'};
    height: ${({size}) => size === 'small' ? '32px' : '40px'};
    border: ${({viewMode}) => viewMode === 'secondary' ? '1px solid #F1F2FE' : 'none'};
    margin: ${({margin}) => margin || 'initial'};
    width: ${({width}) => (typeof width === 'number' ? width + 'px' : width) || 'auto'};
    box-sizing: border-box;
    cursor: ${({disabled}) => disabled ? 'not-allowed' : 'pointer'};
    opacity: ${({disabled}) => disabled ? 0.7 : 1};
`;

export default observer(function(props: IBlockProps) {
    return (
        <Button width={props.width} disabled={props.disabled} margin={props.margin} size={props.size} viewMode={props.viewMode} onClick={props.onClick}>
            {props.caption}
        </Button>
    );
});